// Map to the supported comparttypes in the DB for Rope Shovel Inspections.
export enum MiningShovel_LU_COMPART_TYPE {
    Monoblock = 230,
    TrackRoller = 235,
    Sprocket = 236,
    Idler = 233,
    RareIdler = 446,
    CrawlerFrameGuide = 417
}

// Types of photos available for the Rope Shovel Inspection.
export enum InspectionPhotoType {
    Undefined = 0,
    Inspection_Mandatory_Photo = 1,
    Comparttype_Mandatory_Photo = 2,
    Comparttype_Additional_Photo = 3,
    Measurement_Point_Photo = 4
}

// Used to pre-fill details for the Report Introduction.
export class MiningShovelInspectionOverview {
    public dateOfInspection: Date;
    public customerName: string;
    public equipmentId: number;
    public equipmentMake: string;
    public equipmentModel: string;
    public unitNumber: string;
    public unitSerial: string;
    public undercarriageSMU: string;
    public UCInspector: string;
    public equipmentJobsite: string;
    public equipmentCurrentSMU : string;
    public IsReleased:boolean;


    public systemPrefillContentViewModels : SystemPrefillContentViewModel[];
}

export class CompartMeasurementPoint {
    public measurePointId: number;
    public measurePointName: string;
    public numberOfMeasurements: number;
}

// Holds the list of images for a measurement point.
//export class MeasurementPointImage {
//    public measurePointId: number;
//    public imageData: string;
//    public imageTitle: string;
//    public imageComment: string;
//}

// Generic structure to hold the readings for the left and right side.
export class ReadingValue {
    public location: string;
    public left: number;
    public right: number;
    public leftworn: number;
    public rightworn: number;
}

// Holds the list of readings for a measurement point.
export class MeasurementPointReadings {
    public measurePointId: number;
    public listOfReadings: ReadingValue[];
    public totalCount: number;
    public tool: string;
    public isHidden: boolean;
    public isHiddenAll: boolean;
    public IsTurelyHiddenInDB : boolean;
}

// Holds the list of observations for a measurement point.
export class MeasurementPointObservation {
    public measurePointId: number;
    public observation: string;
    public side: string;
    public desc: string;
}

// Top-level report details.
export class SaveReportParams {
    public MSInspectionID: number;
    public createdUser: number;
    public createdDate: string;
}

// Recommendations
export class RecommendationParams {
    public ReportId: number;
    public RecommendationId: number;
    public RecommendationTitle: string;
    public RecommendationText: string;
}

// Save photo parameters
export class SaveRecommendationPhotoParams {
    public recommendationId: number;
    public photoType: number;
    public photoId: number;
}

// Generic structure to store the inspection photo, id, title and comment.
export class InspectionPhoto {
    public id: number
    public data: string;
    public title: string;
    public comment: string;
    public photoType: number;
    public isHidden: boolean;
    public isLarge: boolean;
    public CompartTypeId : number;
}


export class PhotoCommentUpdateModel{
    public id: number;
    public comment: string;
}

// Introduction
export class IntroductionParams {
    public ReportId: number;
    public IntroId: number;
    public CoverImage: number;
    public IntroText1: string;
    public IntroText2: string;
}

// Holds details for measurement points including readings, images and observations.
export class  MeasurementPointDetails {
    public MeasurePointId: number;
    public MeasurePointName: string;
    public NumberOfMeasurements: number;
    public isHidden: boolean;
    public Readings: MeasurementPointReadings[];
    public Images: InspectionPhoto[];
    public Observations: MeasurementPointObservation[];
}

// Holds details for additional records including readings, images and observations.
export class AdditionalRecordDetails {
    public Title: string;
    public ReadingL: string;
    public ReadingR: string;
    public Tool: string;
}

// Overall Comments for comparttype
export class OverallComments {
    public Id: number;
    public ReportId: number;
    public CompartTypeId: number;
    public Comments: string;
}

// The main structure to hold inspection details for each comparttype.
export class CompartInspection {
    public MeasurementPoints: MeasurementPointDetails[];
    public MandatoryImages: InspectionPhoto[];
    public AdditionalImages: InspectionPhoto[];
    public AdditionalRecords: AdditionalRecordDetails[];
    public CalculatedRecords: AdditionalRecordDetails[];
    public OverallComments: OverallComments;
    public isAdditionalRecordsHidden: boolean;
}

// Report Summary
export class SummaryParams {
    public ReportId: number;
    public SummaryId: number;
    public SummaryText: string;
    public RecommendationOverview: string;
}




//Prefill contents
export class ReportPrefillContentViewModel{
    public Systems : SystemPrefillContentViewModel[];
}


export class SystemPrefillContentViewModel{
    public SystemId : number;
    public CMU : number;
    public SystemSerialNumber : string;
    public Side : number;
    public SystemTypeEnum : number;
}





export enum ChangePhotoCommentAPINames{
    ChangeInspectionMandatoryPhotoComment,
    ChangeMandatoryImageComment,
    ChangeAdditionalImageComment,
    ChangedMeasurementPointsPhotoComment,
}



export class ToggleHideAndShowResult{
    public Id:number;
    public IsHiding : boolean;
    public SavedResult : boolean;
}